import React, { useEffect, useRef, useState } from "react";
import styled, { keyframes } from "styled-components";

const lineAnim = keyframes`
to {
    stroke-dashoffset: 0;
}
`;

const StyledAnimatedMobileTitle = styled.div`
  padding: 1rem 0;
  width: 100%;
  position: relative;

  #role {
    width: 95%;
  }
  #role > path {
    stroke: ${(props) => props.theme.fontColor};
  }
  #role > path:nth-of-type(${1}) {
    stroke-dasharray: ${(props) => props.lengthsArray[0]};
    stroke-dashoffset: ${(props) => props.lengthsArray[0]};
    animation: ${lineAnim} 3.7s ease forwards 1s;
  }
  #role > path:nth-of-type(${2}) {
    stroke-dasharray: ${(props) => props.lengthsArray[1]};
    stroke-dashoffset: ${(props) => props.lengthsArray[1]};
    animation: ${lineAnim} 3.7s ease forwards 1.1s;
  }
  #role > path:nth-of-type(${3}) {
    stroke-dasharray: ${(props) => props.lengthsArray[2]};
    stroke-dashoffset: ${(props) => props.lengthsArray[2]};
    animation: ${lineAnim} 3.7s ease forwards 1.2s;
  }
  #role > path:nth-of-type(${4}) {
    stroke-dasharray: ${(props) => props.lengthsArray[3]};
    stroke-dashoffset: ${(props) => props.lengthsArray[3]};
    animation: ${lineAnim} 3.7s ease forwards 1.3s;
  }
  #role > path:nth-of-type(${5}) {
    stroke-dasharray: ${(props) => props.lengthsArray[4]};
    stroke-dashoffset: ${(props) => props.lengthsArray[4]};
    animation: ${lineAnim} 3.7s ease forwards 1.4s;
  }
  #role > path:nth-of-type(${6}) {
    stroke-dasharray: ${(props) => props.lengthsArray[5]};
    stroke-dashoffset: ${(props) => props.lengthsArray[5]};
    animation: ${lineAnim} 3.7s ease forwards 1.5s;
  }
  #role > path:nth-of-type(${7}) {
    stroke-dasharray: ${(props) => props.lengthsArray[6]};
    stroke-dashoffset: ${(props) => props.lengthsArray[6]};
    animation: ${lineAnim} 3.7s ease forwards 1.6s;
  }
  #role > path:nth-of-type(${8}) {
    stroke-dasharray: ${(props) => props.lengthsArray[7]};
    stroke-dashoffset: ${(props) => props.lengthsArray[7]};
    animation: ${lineAnim} 3.7s ease forwards 1.7s;
  }
  #role > path:nth-of-type(${9}) {
    stroke-dasharray: ${(props) => props.lengthsArray[8]};
    stroke-dashoffset: ${(props) => props.lengthsArray[8]};
    animation: ${lineAnim} 3.7s ease forwards 1.8s;
  }
  #role > path:nth-of-type(${10}) {
    stroke-dasharray: ${(props) => props.lengthsArray[9]};
    stroke-dashoffset: ${(props) => props.lengthsArray[9]};
    animation: ${lineAnim} 3.7s ease forwards 1.9s;
  }
  #role > path:nth-of-type(${11}) {
    stroke-dasharray: ${(props) => props.lengthsArray[10]};
    stroke-dashoffset: ${(props) => props.lengthsArray[10]};
    animation: ${lineAnim} 3.7s ease forwards 2s;
  }
  #role > path:nth-of-type(${12}) {
    stroke-dasharray: ${(props) => props.lengthsArray[11]};
    stroke-dashoffset: ${(props) => props.lengthsArray[11]};
    animation: ${lineAnim} 3.7s ease forwards 2.1s;
  }
  #role > path:nth-of-type(${13}) {
    stroke-dasharray: ${(props) => props.lengthsArray[12]};
    stroke-dashoffset: ${(props) => props.lengthsArray[12]};
    animation: ${lineAnim} 3.7s ease forwards 2.2s;
  }
  #role > path:nth-of-type(${14}) {
    stroke-dasharray: ${(props) => props.lengthsArray[13]};
    stroke-dashoffset: ${(props) => props.lengthsArray[13]};
    animation: ${lineAnim} 3.7s ease forwards 2.3s;
  }
  #role > path:nth-of-type(${15}) {
    stroke-dasharray: ${(props) => props.lengthsArray[14]};
    stroke-dashoffset: ${(props) => props.lengthsArray[14]};
    animation: ${lineAnim} 3.7s ease forwards 2.4s;
  }
  #role > path:nth-of-type(${16}) {
    stroke-dasharray: ${(props) => props.lengthsArray[15]};
    stroke-dashoffset: ${(props) => props.lengthsArray[15]};
    animation: ${lineAnim} 3.7s ease forwards 2.5s;
  }
  #role > path:nth-of-type(${17}) {
    stroke-dasharray: ${(props) => props.lengthsArray[16]};
    stroke-dashoffset: ${(props) => props.lengthsArray[16]};
    animation: ${lineAnim} 3.7s ease forwards 2.6s;
  }
`;

export const AnimatedMobileTitle = () => {
  const [lengths, setLengths] = useState([]);
  const roleRef = useRef(null);
  useEffect(() => {
    let tempLength = [];
    var children = roleRef.current.childNodes;
    children.forEach(function (item) {
      if (item.tagName === "path") {
        tempLength.push(item.getTotalLength());
      }
    });
    setLengths(tempLength);
  }, [window.innerWidth]);
  return (
    <StyledAnimatedMobileTitle lengthsArray={lengths} className="mobile">
      <svg
        id="role"
        ref={roleRef}
        width="306"
        viewBox="0 0 306 139"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <mask
          id="path-1-outside-1"
          maskUnits="userSpaceOnUse"
          x="0.197998"
          y="0.619995"
          width="306"
          height="139"
          fill="black">
          <rect
            fill="white"
            x="0.197998"
            y="0.619995"
            width="306"
            height="139"
          />
          <path d="M3.198 4.39999H25.896V12.2H11.778V27.41H22.854V35.21H11.778V59H3.198V4.39999Z" />
          <path d="M34.6905 4.39999H47.4045C51.8245 4.39999 55.0485 5.43999 57.0765 7.52C59.1045 9.54799 60.1185 12.694 60.1185 16.958V20.312C60.1185 25.98 58.2465 29.568 54.5025 31.076V31.232C56.5825 31.856 58.0385 33.13 58.8705 35.054C59.7545 36.978 60.1965 39.552 60.1965 42.776V52.37C60.1965 53.93 60.2485 55.204 60.3525 56.192C60.4565 57.128 60.7165 58.064 61.1325 59H52.3965C52.0845 58.116 51.8765 57.284 51.7725 56.504C51.6685 55.724 51.6165 54.32 51.6165 52.292V42.308C51.6165 39.812 51.2005 38.07 50.3685 37.082C49.5885 36.094 48.2105 35.6 46.2345 35.6H43.2705V59H34.6905V4.39999ZM46.3905 27.8C48.1065 27.8 49.3805 27.358 50.2125 26.474C51.0965 25.59 51.5385 24.108 51.5385 22.028V17.816C51.5385 15.84 51.1745 14.41 50.4465 13.526C49.7705 12.642 48.6785 12.2 47.1705 12.2H43.2705V27.8H46.3905Z" />
          <path d="M83.2315 59.78C79.0195 59.78 75.7955 58.584 73.5595 56.192C71.3235 53.8 70.2055 50.42 70.2055 46.052V17.348C70.2055 12.98 71.3235 9.6 73.5595 7.208C75.7955 4.816 79.0195 3.62 83.2315 3.62C87.4435 3.62 90.6675 4.816 92.9035 7.208C95.1395 9.6 96.2575 12.98 96.2575 17.348V46.052C96.2575 50.42 95.1395 53.8 92.9035 56.192C90.6675 58.584 87.4435 59.78 83.2315 59.78ZM83.2315 51.98C86.1955 51.98 87.6775 50.186 87.6775 46.598V16.802C87.6775 13.214 86.1955 11.42 83.2315 11.42C80.2675 11.42 78.7855 13.214 78.7855 16.802V46.598C78.7855 50.186 80.2675 51.98 83.2315 51.98Z" />
          <path d="M106.74 4.39999H117.504L125.85 37.082H126.006V4.39999H133.65V59H124.836L114.54 19.142H114.384V59H106.74V4.39999Z" />
          <path d="M151.415 12.2H142.445V4.39999H168.965V12.2H159.995V59H151.415V12.2Z" />
          <path d="M177.799 4.39999H201.199V12.2H186.379V26.63H198.157V34.43H186.379V51.2H201.199V59H177.799V4.39999Z" />
          <path d="M210.815 4.39999H221.579L229.925 37.082H230.081V4.39999H237.725V59H228.911L218.615 19.142H218.459V59H210.815V4.39999Z" />
          <path d="M248.782 4.39999H261.886C266.15 4.39999 269.348 5.544 271.48 7.832C273.612 10.12 274.678 13.474 274.678 17.894V45.506C274.678 49.926 273.612 53.28 271.48 55.568C269.348 57.856 266.15 59 261.886 59H248.782V4.39999ZM261.73 51.2C263.134 51.2 264.2 50.784 264.928 49.952C265.708 49.12 266.098 47.768 266.098 45.896V17.504C266.098 15.632 265.708 14.28 264.928 13.448C264.2 12.616 263.134 12.2 261.73 12.2H257.362V51.2H261.73Z" />
          <path d="M3.198 80.4H16.302C20.566 80.4 23.764 81.544 25.896 83.832C28.028 86.12 29.094 89.474 29.094 93.894V121.506C29.094 125.926 28.028 129.28 25.896 131.568C23.764 133.856 20.566 135 16.302 135H3.198V80.4ZM16.146 127.2C17.55 127.2 18.616 126.784 19.344 125.952C20.124 125.12 20.514 123.768 20.514 121.896V93.504C20.514 91.632 20.124 90.28 19.344 89.448C18.616 88.616 17.55 88.2 16.146 88.2H11.778V127.2H16.146Z" />
          <path d="M39.5655 80.4H62.9655V88.2H48.1455V102.63H59.9235V110.43H48.1455V127.2H62.9655V135H39.5655V80.4Z" />
          <path d="M70.3194 80.4H78.9774L84.5934 122.754H84.7494L90.3654 80.4H98.2434L89.9754 135H78.5874L70.3194 80.4Z" />
          <path d="M107.045 80.4H130.445V88.2H115.625V102.63H127.403V110.43H115.625V127.2H130.445V135H107.045V80.4Z" />
          <path d="M140.061 80.4H148.641V127.2H162.759V135H140.061V80.4Z" />
          <path d="M183.65 135.78C179.438 135.78 176.214 134.584 173.978 132.192C171.742 129.8 170.624 126.42 170.624 122.052V93.348C170.624 88.98 171.742 85.6 173.978 83.208C176.214 80.816 179.438 79.62 183.65 79.62C187.862 79.62 191.086 80.816 193.322 83.208C195.558 85.6 196.676 88.98 196.676 93.348V122.052C196.676 126.42 195.558 129.8 193.322 132.192C191.086 134.584 187.862 135.78 183.65 135.78ZM183.65 127.98C186.614 127.98 188.096 126.186 188.096 122.598V92.802C188.096 89.214 186.614 87.42 183.65 87.42C180.686 87.42 179.204 89.214 179.204 92.802V122.598C179.204 126.186 180.686 127.98 183.65 127.98Z" />
          <path d="M207.159 80.4H219.795C224.059 80.4 227.257 81.544 229.389 83.832C231.521 86.12 232.587 89.474 232.587 93.894V99.276C232.587 103.696 231.521 107.05 229.389 109.338C227.257 111.626 224.059 112.77 219.795 112.77H215.739V135H207.159V80.4ZM219.795 104.97C221.199 104.97 222.239 104.58 222.915 103.8C223.643 103.02 224.007 101.694 224.007 99.822V93.348C224.007 91.476 223.643 90.15 222.915 89.37C222.239 88.59 221.199 88.2 219.795 88.2H215.739V104.97H219.795Z" />
          <path d="M241.927 80.4H265.327V88.2H250.507V102.63H262.285V110.43H250.507V127.2H265.327V135H241.927V80.4Z" />
          <path d="M274.943 80.4H287.657C292.077 80.4 295.301 81.44 297.329 83.52C299.357 85.548 300.371 88.694 300.371 92.958V96.312C300.371 101.98 298.499 105.568 294.755 107.076V107.232C296.835 107.856 298.291 109.13 299.123 111.054C300.007 112.978 300.449 115.552 300.449 118.776V128.37C300.449 129.93 300.501 131.204 300.605 132.192C300.709 133.128 300.969 134.064 301.385 135H292.649C292.337 134.116 292.129 133.284 292.025 132.504C291.921 131.724 291.869 130.32 291.869 128.292V118.308C291.869 115.812 291.453 114.07 290.621 113.082C289.841 112.094 288.463 111.6 286.487 111.6H283.523V135H274.943V80.4ZM286.643 103.8C288.359 103.8 289.633 103.358 290.465 102.474C291.349 101.59 291.791 100.108 291.791 98.028V93.816C291.791 91.84 291.427 90.41 290.699 89.526C290.023 88.642 288.931 88.2 287.423 88.2H283.523V103.8H286.643Z" />
        </mask>
        <path
          d="M3.198 4.39999H25.896V12.2H11.778V27.41H22.854V35.21H11.778V59H3.198V4.39999Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M34.6905 4.39999H47.4045C51.8245 4.39999 55.0485 5.43999 57.0765 7.52C59.1045 9.54799 60.1185 12.694 60.1185 16.958V20.312C60.1185 25.98 58.2465 29.568 54.5025 31.076V31.232C56.5825 31.856 58.0385 33.13 58.8705 35.054C59.7545 36.978 60.1965 39.552 60.1965 42.776V52.37C60.1965 53.93 60.2485 55.204 60.3525 56.192C60.4565 57.128 60.7165 58.064 61.1325 59H52.3965C52.0845 58.116 51.8765 57.284 51.7725 56.504C51.6685 55.724 51.6165 54.32 51.6165 52.292V42.308C51.6165 39.812 51.2005 38.07 50.3685 37.082C49.5885 36.094 48.2105 35.6 46.2345 35.6H43.2705V59H34.6905V4.39999ZM46.3905 27.8C48.1065 27.8 49.3805 27.358 50.2125 26.474C51.0965 25.59 51.5385 24.108 51.5385 22.028V17.816C51.5385 15.84 51.1745 14.41 50.4465 13.526C49.7705 12.642 48.6785 12.2 47.1705 12.2H43.2705V27.8H46.3905Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M83.2315 59.78C79.0195 59.78 75.7955 58.584 73.5595 56.192C71.3235 53.8 70.2055 50.42 70.2055 46.052V17.348C70.2055 12.98 71.3235 9.6 73.5595 7.208C75.7955 4.816 79.0195 3.62 83.2315 3.62C87.4435 3.62 90.6675 4.816 92.9035 7.208C95.1395 9.6 96.2575 12.98 96.2575 17.348V46.052C96.2575 50.42 95.1395 53.8 92.9035 56.192C90.6675 58.584 87.4435 59.78 83.2315 59.78ZM83.2315 51.98C86.1955 51.98 87.6775 50.186 87.6775 46.598V16.802C87.6775 13.214 86.1955 11.42 83.2315 11.42C80.2675 11.42 78.7855 13.214 78.7855 16.802V46.598C78.7855 50.186 80.2675 51.98 83.2315 51.98Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M106.74 4.39999H117.504L125.85 37.082H126.006V4.39999H133.65V59H124.836L114.54 19.142H114.384V59H106.74V4.39999Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M151.415 12.2H142.445V4.39999H168.965V12.2H159.995V59H151.415V12.2Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M177.799 4.39999H201.199V12.2H186.379V26.63H198.157V34.43H186.379V51.2H201.199V59H177.799V4.39999Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M210.815 4.39999H221.579L229.925 37.082H230.081V4.39999H237.725V59H228.911L218.615 19.142H218.459V59H210.815V4.39999Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M248.782 4.39999H261.886C266.15 4.39999 269.348 5.544 271.48 7.832C273.612 10.12 274.678 13.474 274.678 17.894V45.506C274.678 49.926 273.612 53.28 271.48 55.568C269.348 57.856 266.15 59 261.886 59H248.782V4.39999ZM261.73 51.2C263.134 51.2 264.2 50.784 264.928 49.952C265.708 49.12 266.098 47.768 266.098 45.896V17.504C266.098 15.632 265.708 14.28 264.928 13.448C264.2 12.616 263.134 12.2 261.73 12.2H257.362V51.2H261.73Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M3.198 80.4H16.302C20.566 80.4 23.764 81.544 25.896 83.832C28.028 86.12 29.094 89.474 29.094 93.894V121.506C29.094 125.926 28.028 129.28 25.896 131.568C23.764 133.856 20.566 135 16.302 135H3.198V80.4ZM16.146 127.2C17.55 127.2 18.616 126.784 19.344 125.952C20.124 125.12 20.514 123.768 20.514 121.896V93.504C20.514 91.632 20.124 90.28 19.344 89.448C18.616 88.616 17.55 88.2 16.146 88.2H11.778V127.2H16.146Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M39.5655 80.4H62.9655V88.2H48.1455V102.63H59.9235V110.43H48.1455V127.2H62.9655V135H39.5655V80.4Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M70.3194 80.4H78.9774L84.5934 122.754H84.7494L90.3654 80.4H98.2434L89.9754 135H78.5874L70.3194 80.4Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M107.045 80.4H130.445V88.2H115.625V102.63H127.403V110.43H115.625V127.2H130.445V135H107.045V80.4Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M140.061 80.4H148.641V127.2H162.759V135H140.061V80.4Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M183.65 135.78C179.438 135.78 176.214 134.584 173.978 132.192C171.742 129.8 170.624 126.42 170.624 122.052V93.348C170.624 88.98 171.742 85.6 173.978 83.208C176.214 80.816 179.438 79.62 183.65 79.62C187.862 79.62 191.086 80.816 193.322 83.208C195.558 85.6 196.676 88.98 196.676 93.348V122.052C196.676 126.42 195.558 129.8 193.322 132.192C191.086 134.584 187.862 135.78 183.65 135.78ZM183.65 127.98C186.614 127.98 188.096 126.186 188.096 122.598V92.802C188.096 89.214 186.614 87.42 183.65 87.42C180.686 87.42 179.204 89.214 179.204 92.802V122.598C179.204 126.186 180.686 127.98 183.65 127.98Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M207.159 80.4H219.795C224.059 80.4 227.257 81.544 229.389 83.832C231.521 86.12 232.587 89.474 232.587 93.894V99.276C232.587 103.696 231.521 107.05 229.389 109.338C227.257 111.626 224.059 112.77 219.795 112.77H215.739V135H207.159V80.4ZM219.795 104.97C221.199 104.97 222.239 104.58 222.915 103.8C223.643 103.02 224.007 101.694 224.007 99.822V93.348C224.007 91.476 223.643 90.15 222.915 89.37C222.239 88.59 221.199 88.2 219.795 88.2H215.739V104.97H219.795Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M241.927 80.4H265.327V88.2H250.507V102.63H262.285V110.43H250.507V127.2H265.327V135H241.927V80.4Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M274.943 80.4H287.657C292.077 80.4 295.301 81.44 297.329 83.52C299.357 85.548 300.371 88.694 300.371 92.958V96.312C300.371 101.98 298.499 105.568 294.755 107.076V107.232C296.835 107.856 298.291 109.13 299.123 111.054C300.007 112.978 300.449 115.552 300.449 118.776V128.37C300.449 129.93 300.501 131.204 300.605 132.192C300.709 133.128 300.969 134.064 301.385 135H292.649C292.337 134.116 292.129 133.284 292.025 132.504C291.921 131.724 291.869 130.32 291.869 128.292V118.308C291.869 115.812 291.453 114.07 290.621 113.082C289.841 112.094 288.463 111.6 286.487 111.6H283.523V135H274.943V80.4ZM286.643 103.8C288.359 103.8 289.633 103.358 290.465 102.474C291.349 101.59 291.791 100.108 291.791 98.028V93.816C291.791 91.84 291.427 90.41 290.699 89.526C290.023 88.642 288.931 88.2 287.423 88.2H283.523V103.8H286.643Z"
          strokeWidth="3"
          mask="url(#path-1-outside-1)"
        />
      </svg>
    </StyledAnimatedMobileTitle>
  );
};
